import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";

const DailyLogs = ({
  showDailyLogs,
  setShowDailyLogs,
  sendMood,
  note,
  setNote,
}) => {
  const [userThought, setUserThought] = useState("");
  const [submittedThoughts, setSubmittedThoughts] = useState([]);
  const [error, setError] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    const newThought = {
      thought: userThought,
      date: new Date().toLocaleString(),
      id: uuidv4(),
    };
    sendMood();
    // Save mood entry to local storage
    const storedLogs = JSON.parse(localStorage.getItem("dailyLogs")) || [];
    localStorage.setItem(
      "dailyLogs",
      JSON.stringify([...storedLogs, newThought])
    );

    setSubmittedThoughts([...submittedThoughts, newThought]);
    setUserThought("");
    setShowDailyLogs(!showDailyLogs);
  };

  function createLog(e) {
    setUserThought(e.target.value);
    setNote(e.target.value);
  }

  return (
    <div>
      <section>
        <div>
          <div
            className={
              showDailyLogs
                ? "w-full max-w-[600px] bg-white mx-auto my-20 p-10 rounded-lg shadow-inner shadow-black"
                : "hidden"
            }
          >
            <div className="input-button flex items-center justify-between bg-[#D4DDCC] rounded-[30px] pl-5 mb-5">
              <input
                className="font-semibold p-[10px] bg-[transparent] border-0 flex-1 outline-none focus:bg-white focus: rounded-[30px]"
                type="text"
                placeholder="A safe space for your thoughts and feelings..."
                value={userThought}
                onChange={createLog}
              />
              <button
                className="border-0 outline-none py-[16px] px-[50px] bg-[#2A3D19] text-[16px] text-white rounded-[40px]"
                onClick={handleSubmit}
              >
                Enter
              </button>
            </div>
            <span className=" flex flex-center" id="errorMessage">
              {error && <p>{error}</p>}
            </span>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DailyLogs;
